export const loadScripts = (scripts) =>
    new Promise((resolve, reject) => {
        var scriptsToLoad = scripts.map((x) =>
            loadScript(Object.keys(x)[0], Object.values(x)[0])
        )
        Promise.all(scriptsToLoad)
            .then(() => {
                resolve()
            })
            .catch(() => {
                reject()
            })
    })

export const loadScript = (scriptId, url) =>
    new Promise((resolve, reject) => {
        var existingScript = document.getElementById(scriptId)

        if (!existingScript) {
            try {
                var script = document.createElement('script')
                script.src = url
                script.id = scriptId
                script.onload = () => {
                    resolve()
                }
                script.onerror = () => {
                    reject()
                }
                document.head.appendChild(script)
            } catch (e) {
                reject()
            }
        } else {
            resolve()
        }
    })
